import Layout from "@/components/layout/index.vue"
import Login from "@/pages/login/index.vue"

export default[
	{
		path:"/",
		component:Layout,
		redirect:"/home",
		children:[
			{
				path: "/home",
				name: "Beranda",
				meta: { index: 0 },
				component: () => import("@/pages/home/total.vue"),
			  },
			  {
				path: "/perm",
				name: "Manajemen Menu",
				meta: { index: 0 },
				component: () => import("@/pages/sys/perm/perm.vue"),
			  },
			  {
				path: "/role",
				name: "Manajemen Peran",
				meta: { index: 0 },
				component: () => import("@/pages/sys/role/role.vue"),
			  },
			  {
				path: "/role/add",
				name: "Tambahkan Peran",
				meta: { index: 0 },
				component: () => import("@/pages/sys/role/add.vue"),
			  },
			  {
				path: "/role/edit",
				name: "Edit Peran",
				meta: { index: 0 },
				component: () => import("@/pages/sys/role/edit.vue"),
			  },
			  {
				path: "/user",
				name: "Manajemen Pengguna",
				meta: { index: 0 },
				component: () => import("@/pages/sys/user/user.vue"),
			  },
			  {
				path: "/derate",
				name: "Pengurangan Penagihan",
				meta: { index: 0 },
				component: () => import("@/pages/call/accountBook/derate.vue"),
			  },
			  {
				path: "/estimate",
				name: "Estimasi 7 Hari",
				meta: { index: 0 },
				component: () => import("@/pages/call/accountBook/estimate.vue"),
			  },
			  {
				path: "/daycall",
				name: "Ikhtisar Data Harian",
				meta: { index: 0 },
				component: () => import("@/pages/call/accountBook/daycall.vue"),
			  },
			  {
				path: "/loan",
				name: "Data Pasca Pinjaman",
				meta: { index: 0 },
				component: () => import("@/pages/call/callreport/loan.vue"),
			  },
			  {
				path: "/callreport",
				name: "Laporan Data Real-time Penagihan",
				meta: { index: 0 },
				component: () => import("@/pages/call/callreport/index.vue"),
			  },
			  {
				path: "/log",
				name: "Manajemen Log",
				meta: { index: 0 },
				component: () => import("@/pages/sys/log/log.vue"),
			  },
			  {
				path: "/userlist",
				name: "Manajemen Pengguna APP",
				meta: { index: 0 },
				component: () => import("@/pages/userlist/user.vue"),
			  },
			  {
				path: "/userlist/extend",
				name: "Informasi Autentikasi Pengguna",
				meta: { index: 0 },
				component: () => import("@/pages/userlist/extend.vue"),
			  },
			  {
				path: "/callorder/call",
				name: "Informasi Penagihan Pesanan",
				meta: { index: 0 },
				component: () => import("@/pages/callorder/call.vue"),
			  },
			  {
				path: "/repayment",
				name: "Manajemen Pembayaran Pengguna",
				meta: { index: 0 },
				component: () => import("@/pages/repayment/index.vue"),
			  },
			  {
				path: "/superfluous",
				name: "Daftar Data Pembayaran Berlebih Pengguna",
				meta: { index: 0 },
				component: () => import("@/pages/repayment/superfluous.vue"),
			  },
			  {
				path: "/rollover",
				name: "Manajemen Perpanjangan/Keterlambatan Pengguna",
				meta: { index: 0 },
				component: () => import("@/pages/rollover/index.vue"),
			  },
			  {
				path: "/externalorder",
				name: "Manajemen Pesanan Eksternal",
				meta: { index: 0 },
				component: () => import("@/pages/externalorder/index.vue"),
			  },
			  {
				path: "/product",
				name: "Konfigurasi Produk",
				meta: { index: 0 },
				component: () => import("@/pages/sys/product/index.vue"),
			  },
			  {
				path: "/account",
				name: "Konfigurasi Periode Akuntansi",
				meta: { index: 0 },
				component: () => import("@/pages/call/accountBook/index.vue"),
			  },
			  {
				path: "/classify",
				name: "Konfigurasi Klasifikasi Penagihan",
				meta: { index: 0 },
				component: () => import("@/pages/call/classify/index.vue"),
			  },
			  {
				path: "/group",
				name: "Konfigurasi Grup",
				meta: { index: 0 },
				component: () => import("@/pages/call/group/index.vue"),
			  },
			  {
				path: "/parameter",
				name: "Konfigurasi Parameter Sistem",
				meta: { index: 0 },
				component: () => import("@/pages/sys/parameter/index.vue"),
			  },
			  {
				path: "/limit",
				name: "Konfigurasi Limit",
				meta: { index: 0 },
				component: () => import("@/pages/sys/limit/index.vue"),
			  },
			  {
				path: "/order",
				name: "Daftar Pesanan",
				meta: { index: 0 },
				component: () => import("@/pages/order/index.vue"),
			  },
			  {
				path: "/payError",
				name: "Daftar Pesanan Gagal Pencairan",
				meta: { index: 0 },
				component: () => import("@/pages/order/payError.vue"),
			  },
			  {
				path: "/callorder",
				name: "Pesanan Penagihan",
				meta: { index: 0 },
				component: () => import("@/pages/callorder/index.vue"),
			  },
			  {
				path: "/mycall",
				name: "Pesanan Penagihan Saya",
				meta: { index: 0 },
				component: () => import("@/pages/mycall/index.vue"),
			  },
			  {
				path: "/mycallsucc",
				name: "Pesanan Penagihan Berhasil Saya",
				meta: { index: 0 },
				component: () => import("@/pages/mycall/callsucc.vue"),
			  },
			  {
				path: "/mycallsuccyq",
				name: "Pesanan Keterlambatan Penagihan Berhasil Saya",
				meta: { index: 0 },
				component: () => import("@/pages/mycall/callsuccyq.vue"),
			  },
			  {
				path: "/proofquery",
				name: "Permintaan Bukti",
				meta: { index: 0 },
				component: () => import("@/pages/mycall/proofquery.vue"),
			  },
			  {
				path: "/callTotal",
				name: "Statistik Penagihan",
				meta: { index: 0 },
				component: () => import("@/pages/mycall/callTotal.vue"),
			  },
			  {
				path: "/channelAn",
				name: "Analisis Saluran Pemasaran",
				meta: { index: 0 },
				component: () => import("@/pages/bazaar/channelAn.vue"),
			  },
			  {
				path: "/complexPower",
				name: "Statistik Tingkat Pinjaman Ulang",
				meta: { index: 0 },
				component: () => import("@/pages/bazaar/complexPower.vue"),
			  },
			  {
				path: "/callOldTotal",
				name: "Statistik Historis Penagihan",
				meta: { index: 0 },
				component: () => import("@/pages/mycall/callOldTotal.vue"),
			  },
			  {
				path: "/queryDayDetail",
				name: "Lihat Detail Harian",
				meta: { index: 0 },
				component: () => import("@/pages/mycall/queryDayDetail.vue"),
			  },
			  {
				path: "/labour",
				name: "Push Manual",
				meta: { index: 0 },
				component: () => import("@/pages/info/labour.vue"),
			  },
			  {
				path: "/push",
				name: "Daftar Push",
				meta: { index: 0 },
				component: () => import("@/pages/info/push.vue"),
			  },
			  {
				path: "/plantilla",
				name: "Template Pesan",
				meta: { index: 0 },
				component: () => import("@/pages/info/plantilla.vue"),
			  },
			  {
				path: "/usercheck",
				name: "Verifikasi Informasi Pengguna",
				meta: { index: 0 },
				component: () => import("@/pages/check/user.vue"),
			  },
			  {
				path: "/cardcheck",
				name: "Verifikasi Informasi KTP",
				meta: { index: 0 },
				component: () => import("@/pages/check/card.vue"),
			  },
			  {
				path: "/ordercheck",
				name: "Verifikasi Pesanan",
				meta: { index: 0 },
				component: () => import("@/pages/check/order.vue"),
			  },
			  {
				path: "/calldetail",
				name: "Detail Statistik Historis Penagihan",
				meta: { index: 0 },
				component: () => import("@/pages/mycall/calldetail.vue"),
			  },
			  {
				path: "/changepass",
				name: "Ubah Kata Sandi",
				meta: { index: 0 },
				component: () => import("@/pages/sys/user/changepass.vue"),
			  },
			  {
				path: "/datamonitor",
				name: "Monitor Data",
				meta: { index: 0 },
				component: () => import("@/pages/monitor/date.vue"),
			  },
			  {
				path: "/categor",
				name: "Tingkat Pengguna",
				meta: { index: 0 },
				component: () => import("@/pages/monitor/categor.vue"),
			  },
			  {
				path: "/walky",
				name: "Daftar Rekaman Telepon",
				meta: { index: 0 },
				component: () => import("@/pages/walky/index.vue"),
			  },
			  {
				path: "/profit",
				name: "Statistik Keuntungan",
				meta: { index: 0 },
				component: () => import("@/pages/mycall/profit.vue"),
			  },
			  {
				path: "/tellist",
				name: "Daftar Telemarketing",
				meta: { index: 0 },
				component: () => import("@/pages/tel/tellist.vue"),
			  },
			  {
				path: "/telGroup",
				name: "Tim Telemarketing",
				meta: { index: 0 },
				component: () => import("@/pages/tel/telGroup.vue"),
			  },
			  {
				path: "/telWorkTotal",
				name: "Statistik Beban Kerja Telemarketing",
				meta: { index: 0 },
				component: () => import("@/pages/tel/telWorkTotal.vue"),
			  },
			  {
				path: "/telPer",
				name: "Laporan Kinerja Agen Telemarketing Yang lama",
				meta: { index: 0 },
				component: () => import("@/pages/tel/telPer.vue"),
			  },
			  {
				path: "/telPerNew",
				name: "Laporan Kinerja Agen Telemarketing baru",
				meta: { index: 0 },
				component: () => import("@/pages/tel/telPerNew.vue"),
			  },
			  {
				path: "/telInfo",
				name: "Catatan Pelacakan Telemarketing",
				meta: { index: 0 },
				component: () => import("@/pages/tel/telInfo.vue"),
			  },
			  {
				path: "/activityLevel",
				name: "Keaktifan pelanggan",
				meta: { index: 0 },
				component: () => import("@/pages/tel/activityLevel.vue"),
			  },
			  {
				path: "/userInfo",
				name: "Informasi pengguna",
				meta: { index: 0 },
				component: () => import("@/pages/tel/userInfo.vue"),
			  },
			  {
				path: "/myTelList",
				name: "Daftar listrikku",
				meta: { index: 0 },
				component: () => import("@/pages/tel/myTelList.vue"),
			  },
			  {
				path: "/mySuccessTel",
				name: "Daftar pin listrik untuk kesuksesanku",
				meta: { index: 0 },
				component: () => import("@/pages/tel/mySuccessTelList.vue"),
			  },
			  {
				path: "/allconfig",
				name: "Mengalokasikan konfigurasi",
				meta: { index: 0 },
				component: () => import("@/pages/tel/allconfig.vue"),
			  },
			  {
				path: "/registerPay",
				name: "Laporan transaksi registrasi",
				meta: { index: 0 },
				component: () => import("@/pages/report/registerPay.vue"),
			  },
			  {
				path: "/loanInfo",
				name: "Pinjaman",
				meta: { index: 0 },
				component: () => import("@/pages/report/loanInfo.vue"),
			  },
			  {
				path: "/dueDate",
				name: "Masa berlakunya sudah habis",
				meta: { index: 0 },
				component: () => import("@/pages/report/dueDate.vue"),
			  },
			  {
				path: "/reLending",
				name: "Kembali padamu.",
				meta: { index: 0 },
				component: () => import("@/pages/report/reLending.vue"),
			  },
			  {
				path: "/telProfit",
				name: "keuntungan",
				meta: { index: 0 },
				component: () => import("@/pages/report/profit.vue"),
			  },
			  {
				path: "/loanBalance",
				name: "Pada saldo pinjaman",
				meta: { index: 0 },
				component: () => import("@/pages/report/loanBalance.vue"),
			  },
			  {
				path: "/pushtotal",
				name: "Push Total",
				meta: { index: 0 },
				component: () => import("@/pages/report/pushtotal.vue"),
			  },
			  {
				path: "/productlist",
				name: "产品列表",
				meta: { index: 0 },
				component: () => import("@/pages/product/productlist.vue"),
			  },
			  {
				path: "/creditline",
				name: "授信配置",
				meta: { index: 0 },
				component: () => import("@/pages/product/creditline.vue"),
			  },
			  {
				path: "/increase",
				name: "提额配置",
				meta: { index: 0 },
				component: () => import("@/pages/product/increase.vue"),
			  },

			  {
				path: "/groupbusy",
				name: "Daftar call grup",
				meta: { index: 0 },
				component: () => import("@/pages/groupbusy/groupbusy.vue"),
			  },
			  {
				path: "/myanswer",
				name: "Jawaban saya",
				meta: { index: 0 },
				component: () => import("@/pages/groupbusy/myanswer.vue"),
			  },
			  {
				path: "/answersuccess",
				name: "Menanggapi daftar sukses transisi",
				meta: { index: 0 },
				component: () => import("@/pages/groupbusy/answersuccess.vue"),
			  },

			  {
				path: "/error/403",
				name: "Tidak Ada Akses",
				meta: { index: 15 },
				component: () => import("@/pages/error/403.vue"),
			  },
			  {
				path: "/error/500",
				name: "Kesalahan Server",
				meta: { index: 16 },
				component: () => import("@/pages/error/500.vue"),
			  },
			  {
				path: "/error/400",
				name: "Kesalahan 400",
				meta: { index: 16 },
				component: () => import("@/pages/error/400.vue"),
			  }
		]
	},
	{
		path:"/login",
		name:"登录",
		component:Login,
	}
	
]



